import { useTranslation } from 'react-i18next'

import styles from './JournalToolbar.module.scss'

const JournalToolbar = ({ lesson, dirty, saving, onSave, onReset }) => {
  const { t } = useTranslation('common')

  return (
    <div className={`unv-card ${styles.header}`}>
      <div>
        <h1 className={styles.title}>
          {t('journal.title')}
          {lesson?.subject_name ? ` · ${lesson.subject_name}` : ''}
          {lesson?.group_name ? ` · ${lesson.group_name}` : ''}
        </h1>
        <div className={styles.muted}>{t('journal.shortcuts_hint')}</div>
      </div>
      <div className={styles.actions}>
        <button className="unv-btn" disabled={!dirty || saving} onClick={onSave}>
          {saving ? t('journal.saving') : t('common.save')}
        </button>
        <button className="unv-btn unv-btn--ghost" onClick={onReset} disabled={!dirty}>
          {t('common.reset')}
        </button>
      </div>
    </div>
  )
}

export default JournalToolbar
